import { AcrValues, ActingType, BaJwt } from '@oiambk/oiam-oauth-types';
import log from 'loglevel';
import { EServiceConfig } from '../services/eservice-config';

export class LoopBreakerData {
  requestedAcrValues: AcrValues;
  forcedBafor: string[];
  requestedAccountLink: string;
  requestedCustomstate: any;
  currentBafor: string[];
  currentActingtype: ActingType;
  currentAuthnlevel: string;

  constructor(eServiceconfig: EServiceConfig, baJwt: BaJwt) {
    this.requestedAcrValues = eServiceconfig.acrValues;
    this.requestedAccountLink = eServiceconfig.accountLink;
    this.requestedCustomstate = eServiceconfig.customstate;
    this.forcedBafor = eServiceconfig.forcedActingOnBehalfOf;
    this.currentAuthnlevel = baJwt?.payload['authn-level'];
    this.currentActingtype = baJwt?.payload['acting-type'];
    this.currentBafor = baJwt?.payload['acting-on-behalf-of'];
  }

  toString(): string {
    try {
      const strVal = JSON.stringify(this);
      return btoa(strVal);
    } catch (e) {
      log.error(e);
    }
    return '';
  }

  static fromString(base64Str: string): LoopBreakerData {
    try {
      const strVal = atob(base64Str);
      return JSON.parse(strVal);
    } catch (e) {
      log.error(e);
    }
  }
}
